import { render, staticRenderFns } from "./OrganizationLoadGuard.vue?vue&type=template&id=0530749a&scoped=true&"
import script from "./OrganizationLoadGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationLoadGuard.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationLoadGuard.vue?vue&type=style&index=0&id=0530749a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530749a",
  null
  
)

export default component.exports